import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WizardStep, WizardSteps } from '../wizard.model';

@Component({
    selector: 'dgx-wizard-navigation',
    templateUrl: './wizard-navigation.component.html',
    styleUrls: ['./wizard-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WizardNavigationComponent
  implements AfterViewInit, OnChanges, OnInit
{
  @Input() public steps: WizardSteps;
  @Input() public isMobile: boolean = false;

  @Output() public clickNavigation = new EventEmitter<WizardStep>();

  public i18n: { [key: string]: string } = {};

  public mobileOpen: boolean = false;
  public mobileActiveStep: WizardStep;

  constructor(private translate: TranslateService) {}

  @HostListener('window:resize', ['$event'])
  public onResize(event: Event) {
    this.closeMobile();
  }

  public ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'steps': {
            this.mobileActiveStep = changes[propName].currentValue.filter(
              (step: WizardStep) => step.isActive
            )[0];
            this.i18n.A11y_WizardClickExpand = this.translate.instant(
              'A11y_WizardClickExpand',
              { label: this.mobileActiveStep?.label }
            );
          }
        }
      }
    }
  }

  public ngOnInit() {
    this.i18n.A11y_WizardNavType = this.translate.instant('A11y_WizardNavType');
  }

  public ngAfterViewInit() {
    const a11yHeader = document.getElementById('a11yHeader');
    if (a11yHeader) {
      a11yHeader.focus();
    }
  }

  public onClick(event: Event, step: WizardStep): void {
    if (step.isCurrent || step.isCompleted) {
      this.closeMobile();
      this.clickNavigation.emit(step);
    }
  }

  public openMobile() {
    if (!this.isMobile) {
      return;
    }
    this.mobileOpen = true;
  }

  public closeMobile() {
    if (!this.isMobile) {
      return;
    }
    this.mobileOpen = false;
  }
}
